import {inject, Injectable} from '@angular/core';
import {CreateFactoryBankDetails, FactoryBankDetails} from "../types/factory-bank-details-modal.types";
import {factoryBankDetailsResourceType} from "../configs/factory-bank-details-modal-configs";
import {BaseModalApiService} from "../../../../../../../core/components/modals/services/base-modal-api.service";
import {GetDataInModalParams} from "../../../../types/product-card-modals.types";
import {ProductCardApiService} from "../../../../services-api/product-card-api.service";
import {RecordUpdateRequestParams} from "../../../../../../../core/types/records-table.types";
import {RecordTableApiService} from "../../../../../../../core/services-api/record-table-api.service";

@Injectable({
  providedIn: 'root'
})
export class FactoryBankDetailsModalService {
  private baseModalApiService: BaseModalApiService = inject(BaseModalApiService);
  private productCardApiService: ProductCardApiService = inject(ProductCardApiService);
  private recordTableApiService: RecordTableApiService = inject(RecordTableApiService);

  public createFactoryBankDetails(createFactoryBankDetails: CreateFactoryBankDetails): Promise<FactoryBankDetails> {
    return new Promise((resolve, reject) => {
      this.baseModalApiService.createDataInModal<CreateFactoryBankDetails, FactoryBankDetails>(createFactoryBankDetails, factoryBankDetailsResourceType.path).subscribe({
        next: (data) => resolve(data),
        error: (error) => reject(error)
      });
    });
  }

  public getDataInModal<T>(technicalParametersId: number): Promise<Array<T>> {
    const params: GetDataInModalParams = {
      path: `${factoryBankDetailsResourceType.path}/`,
      queryParams: { technicalParametersId: technicalParametersId }
    };

    return new Promise((resolve, reject) => {
      this.productCardApiService.fetchDataInModal<T>(params).subscribe({
        next: (data) => resolve(data),
        error: (error) => reject(error)
      });
    });
  }

  public updatedRecordField<T>(params: RecordUpdateRequestParams): Promise<T> {
    return new Promise((resolve, reject) => {
      this.recordTableApiService.updateRecord<T>(params).subscribe({
        next: (recordData: T) => resolve(recordData),
        error: (error) => reject(error)
      });
    });
  }
}
